import {measureDef, unitMap} from "./base";


const metric: unitMap = {
  lx: {
    name: {
      singular: 'Lux',
      plural: 'Lux',
    },
    to_anchor: 1,
  },
};
const imperial: unitMap = {
  'ft-cd': {
    name: {
      singular: 'Foot-candle',
      plural: 'Foot-candles',
    },
    to_anchor: 1,
  },
};
export const IlluminanceDef:measureDef = {
  type: 'illuminance',
  metric: metric,
  imperial: imperial,
  _anchors: {
    metric: {
      unit: 'lx',
      ratio: 1 / 10.76391,
    },
    imperial: {
      unit: 'ft-cd',
      ratio: 10.76391,
    },
  },
};
